import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityBranch } from "../../entity/EntityBranch";

export class DtoBranchsGetReq extends EntityBranch {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_branch_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
